var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c(
          "div",
          {
            staticClass:
              "experience--template page-template page-transition z-content",
          },
          [
            _c("div", { staticClass: "relative" }, [
              _c(
                "div",
                {
                  staticClass: "relative container-fluid  mw9 center taste-top",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "row relative center height-rest mb4 mt4-ns",
                    },
                    [
                      _c("div", { staticClass: "w-100  col-sm-6" }, [
                        _c("img", {
                          staticClass: "img-responsive",
                          attrs: { src: "/uploads/GastroMagic stage.jpg" },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "relative col-xs-12 col-sm-6 ph0" },
                        [
                          _c(
                            "h1",
                            {
                              directives: [
                                {
                                  name: "scrollanimation",
                                  rawName: "v-scrollanimation",
                                },
                              ],
                              staticClass:
                                "db dn-ns f-page-title ttu tl center lh-heading pr0-ns is-blenny is-navy mw7-ns",
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.page.seo_title) +
                                  "\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "dn des-rest db-ns abs-vert-center center",
                            },
                            [
                              _c(
                                "h1",
                                {
                                  staticClass:
                                    "mw7-ns tl center pl3 fiveem lh-heading ttu is-blenny is-navy",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.page.seo_title) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "db des-rest2 relative mb4 mb4-ns w-100 f22px is-tablet-regular link-bold lh-copy cms-content",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.marked(_vm.page.description)
                                  ),
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "relative z-content pb5-ns" }, [
                _c(
                  "section",
                  {
                    staticClass:
                      "relative mw12 flex flex-row bg-beige pb6 pb0-ns margin-in",
                  },
                  [
                    _vm.isWindowWidthMobile == true
                      ? _c(
                          "div",
                          { staticClass: "bg-beige w-100 dn-ns mobile-exp" },
                          [
                            _c("div", {
                              staticClass:
                                "db des-rest2 relative mb4 mb4-ns w-100 f22px is-tablet-regular link-bold lh-copy cms-content",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.marked(_vm.page.description)
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "relative acc-height",
                                style: {
                                  "min-height":
                                    68 * _vm.page.experiences.length + "px",
                                },
                              },
                              [
                                _c("div", { staticClass: "mobile-acc" }),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.page.experiences,
                                  function (topic, key, index) {
                                    return _c("div", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.mobileActive == key,
                                          expression: "mobileActive == key",
                                        },
                                      ],
                                      class:
                                        "bg-cream-" +
                                        topic.color_theme.bg +
                                        "-split-after mobile-acc",
                                    })
                                  }
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.page.experiences,
                                  function (topic, key, index) {
                                    return topic.is_published
                                      ? _c(
                                          "div",
                                          {
                                            class:
                                              "theme-" + topic.color_theme.main,
                                          },
                                          [
                                            topic.is_link
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "mobile-info relative z-0",
                                                    class:
                                                      _vm.mobileActive == key,
                                                  },
                                                  [
                                                    _c("div", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "relative overflow-hidden info-height",
                                                        },
                                                        [
                                                          _c("div", {
                                                            staticClass: "info",
                                                            staticStyle: {
                                                              display: "none",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _c(
                                                  "accordion",
                                                  {
                                                    class: {
                                                      "negitive-margin":
                                                        _vm.mobileActive == key,
                                                    },
                                                    attrs: {
                                                      type: "mobile-info",
                                                      index: key,
                                                      mobileActive:
                                                        _vm.mobileActive,
                                                      resizing:
                                                        _vm.$refs.exprow,
                                                    },
                                                    on: {
                                                      "update:mobileActive":
                                                        function ($event) {
                                                          _vm.mobileActive =
                                                            $event
                                                        },
                                                      "update:mobile-active":
                                                        function ($event) {
                                                          _vm.mobileActive =
                                                            $event
                                                        },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      {
                                                        slot: "parent-nav-link",
                                                      },
                                                      [
                                                        _c(
                                                          "h3",
                                                          {
                                                            staticClass:
                                                              "f3 ttu is-tablet-bold dib relative is-beige",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                topic.title
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "template",
                                                      { slot: "sub-nav-links" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "z-4 relative",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "pv5",
                                                                attrs: {
                                                                  id: topic.slug,
                                                                },
                                                              },
                                                              [
                                                                topic.is_phase1
                                                                  ? _c(
                                                                      "div",
                                                                      {},
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "f25px is-tablet-regular pb4 ph4-m ph6-l lh-copy container-fluid topic-copy",
                                                                            domProps:
                                                                              {
                                                                                innerHTML:
                                                                                  _vm._s(
                                                                                    _vm.marked(
                                                                                      topic.description
                                                                                    )
                                                                                  ),
                                                                              },
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        topic.phase1_video_id
                                                                          ? _c(
                                                                              "bg-vimeo-video-embed",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    vimeoVideoId:
                                                                                      topic.phase1_video_id,
                                                                                  },
                                                                              }
                                                                            )
                                                                          : _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "img-responsive ph4 pr0-ns",
                                                                                attrs:
                                                                                  {
                                                                                    src: topic.phase1_image,
                                                                                  },
                                                                              }
                                                                            ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _c(
                                                                      "div",
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "f20px is-tablet-regular pb4 ph4 lh-copy topic-copy",
                                                                            domProps:
                                                                              {
                                                                                innerHTML:
                                                                                  _vm._s(
                                                                                    _vm.marked(
                                                                                      topic.description
                                                                                    )
                                                                                  ),
                                                                              },
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _vm._l(
                                                                          topic.items,
                                                                          function (
                                                                            event,
                                                                            eIndex
                                                                          ) {
                                                                            return _c(
                                                                              "div",
                                                                              {
                                                                                ref: "exprow",
                                                                                refInFor: true,
                                                                                staticClass:
                                                                                  "exp-row",
                                                                                class:
                                                                                  {
                                                                                    colorActive:
                                                                                      _vm.desktopActive2 ==
                                                                                      eIndex,
                                                                                  },
                                                                                on: {
                                                                                  mouseover:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      _vm.desktopActive2 =
                                                                                        eIndex
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "transition",
                                                                                  {
                                                                                    on: {
                                                                                      beforeEnter:
                                                                                        _vm.beforeEnter2,
                                                                                      enter:
                                                                                        _vm.enter2,
                                                                                      leave:
                                                                                        _vm.leave2,
                                                                                    },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        directives:
                                                                                          [
                                                                                            {
                                                                                              name: "show",
                                                                                              rawName:
                                                                                                "v-show",
                                                                                              value:
                                                                                                _vm.desktopActive2 !==
                                                                                                eIndex,
                                                                                              expression:
                                                                                                "desktopActive2 !== eIndex",
                                                                                            },
                                                                                          ],
                                                                                        staticClass:
                                                                                          "relative pa4 w-100",
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "row middle-sm",
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "col-xs-12 col-sm-6 pv4",
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "img",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "db relative center w-100",
                                                                                                    attrs:
                                                                                                      {
                                                                                                        src: event.image,
                                                                                                      },
                                                                                                  }
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "col-xs-12 col-sm-6",
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "h4",
                                                                                                  {
                                                                                                    ref: event.title,
                                                                                                    refInFor: true,
                                                                                                    staticClass:
                                                                                                      "f3 is-tablet-wide-bold pb2 is-navy",
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        event.title
                                                                                                      )
                                                                                                    ),
                                                                                                  ]
                                                                                                ),
                                                                                                _vm._v(
                                                                                                  " "
                                                                                                ),
                                                                                                event.text
                                                                                                  ? _c(
                                                                                                      "div",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "f15px is-tablet-regular pb3 lh-copy",
                                                                                                        domProps:
                                                                                                          {
                                                                                                            innerHTML:
                                                                                                              _vm._s(
                                                                                                                _vm.marked(
                                                                                                                  event.text
                                                                                                                )
                                                                                                              ),
                                                                                                          },
                                                                                                      }
                                                                                                    )
                                                                                                  : _vm._e(),
                                                                                              ]
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "transition",
                                                                                  {
                                                                                    on: {
                                                                                      beforeEnter:
                                                                                        _vm.beforeEnter,
                                                                                      enter:
                                                                                        _vm.enter,
                                                                                      leave:
                                                                                        _vm.leave,
                                                                                    },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        directives:
                                                                                          [
                                                                                            {
                                                                                              name: "show",
                                                                                              rawName:
                                                                                                "v-show",
                                                                                              value:
                                                                                                _vm.desktopActive2 ==
                                                                                                eIndex,
                                                                                              expression:
                                                                                                "desktopActive2 == eIndex",
                                                                                            },
                                                                                          ],
                                                                                        staticClass:
                                                                                          "pa4 w-100",
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "row middle-sm",
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "col-xs-12 col-sm-6",
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "img",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "db relative center w-100",
                                                                                                    attrs:
                                                                                                      {
                                                                                                        src: event.image,
                                                                                                      },
                                                                                                  }
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "col-xs-12 col-sm-6 mt3 cms-content is-experience",
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "h4",
                                                                                                  {
                                                                                                    ref: event.title,
                                                                                                    refInFor: true,
                                                                                                    staticClass:
                                                                                                      "f-2 is-tablet-wide-bold pb2 is-beige",
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        event.title
                                                                                                      )
                                                                                                    ),
                                                                                                  ]
                                                                                                ),
                                                                                                _vm._v(
                                                                                                  " "
                                                                                                ),
                                                                                                event.text
                                                                                                  ? _c(
                                                                                                      "div",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "f15px is-tablet-regular pb3 lh-copy is-beige",
                                                                                                        domProps:
                                                                                                          {
                                                                                                            innerHTML:
                                                                                                              _vm._s(
                                                                                                                _vm.marked(
                                                                                                                  event.text
                                                                                                                )
                                                                                                              ),
                                                                                                          },
                                                                                                      }
                                                                                                    )
                                                                                                  : _vm._e(),
                                                                                              ]
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            )
                                                                          }
                                                                        ),
                                                                      ],
                                                                      2
                                                                    ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  2
                                                ),
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  }
                                ),
                              ],
                              2
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isWindowWidthMobile == false
                      ? _c(
                          "div",
                          { staticClass: "dn relative flex-ns flex-grow-1" },
                          [
                            _c("div", { staticClass: "pic-left4" }, [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "scrollanimation",
                                      rawName: "v-scrollanimation",
                                    },
                                  ],
                                  staticClass:
                                    "dn db-ns bigger-img icon-image relative nt4 nl5-ns",
                                },
                                [
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "scrollanimation",
                                        rawName: "v-scrollanimation",
                                      },
                                    ],
                                    staticClass: "mw21rem icon-2 icon-margin",
                                    attrs: {
                                      src: "/uploads/OL20-OL21_Icons/Hamburger_Icon/Hamburger_Icon_SVG/Hamburger_Icon_Infrared.svg",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "scrollanimation",
                                        rawName: "v-scrollanimation",
                                      },
                                    ],
                                    staticClass: "mw21rem icon-2 icon-margin",
                                    attrs: {
                                      src: "/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Blue.svg",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "scrollanimation",
                                        rawName: "v-scrollanimation",
                                      },
                                    ],
                                    staticClass: "mw21rem icon-2 icon-margin",
                                    attrs: {
                                      src: "/uploads/OL20-OL21_Icons/Hamburger_Icon/Hamburger_Icon_SVG/Hamburger_Icon_Infrared.svg",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "scrollanimation",
                                        rawName: "v-scrollanimation",
                                      },
                                    ],
                                    staticClass: "mw21rem icon-2 icon-margin",
                                    attrs: {
                                      src: "/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Blue.svg",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "scrollanimation",
                                        rawName: "v-scrollanimation",
                                      },
                                    ],
                                    staticClass: "mw21rem icon-2 icon-margin",
                                    attrs: {
                                      src: "/uploads/OL20-OL21_Icons/Hamburger_Icon/Hamburger_Icon_SVG/Hamburger_Icon_Infrared.svg",
                                    },
                                  }),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "pic-right4" }, [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "scrollanimation",
                                      rawName: "v-scrollanimation",
                                    },
                                  ],
                                  staticClass:
                                    "dn db-ns bigger-img icon-image relative nt4 nl5-ns",
                                },
                                [
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "scrollanimation",
                                        rawName: "v-scrollanimation",
                                      },
                                    ],
                                    staticClass: "mw21rem icon-2 icon-margin",
                                    attrs: {
                                      src: "/uploads/OL20-OL21_Icons/Hamburger_Icon/Hamburger_Icon_SVG/Hamburger_Icon_Infrared.svg",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "scrollanimation",
                                        rawName: "v-scrollanimation",
                                      },
                                    ],
                                    staticClass: "mw21rem icon-2 icon-margin",
                                    attrs: {
                                      src: "/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Blue.svg",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "scrollanimation",
                                        rawName: "v-scrollanimation",
                                      },
                                    ],
                                    staticClass: "mw21rem icon-2 icon-margin",
                                    attrs: {
                                      src: "/uploads/OL20-OL21_Icons/Hamburger_Icon/Hamburger_Icon_SVG/Hamburger_Icon_Infrared.svg",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "scrollanimation",
                                        rawName: "v-scrollanimation",
                                      },
                                    ],
                                    staticClass: "mw21rem icon-2 icon-margin",
                                    attrs: {
                                      src: "/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Blue.svg",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "scrollanimation",
                                        rawName: "v-scrollanimation",
                                      },
                                    ],
                                    staticClass: "mw21rem icon-2 icon-margin",
                                    attrs: {
                                      src: "/uploads/OL20-OL21_Icons/Hamburger_Icon/Hamburger_Icon_SVG/Hamburger_Icon_Infrared.svg",
                                    },
                                  }),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.page.experiences, function (topic, key) {
                              return topic.is_published
                                ? _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.$route.name == topic.slug ||
                                            (_vm.desktopActive == key &&
                                              _vm.$route.name ==
                                                "gastro-magic"),
                                          expression:
                                            "$route.name == topic.slug || (desktopActive == key && $route.name == 'gastro-magic')",
                                        },
                                      ],
                                      staticClass: "w-100 is-black",
                                    },
                                    [
                                      _c("div", {
                                        class:
                                          "bg-cream-" +
                                          topic.color_theme.bg +
                                          "-split-after",
                                      }),
                                      _vm._v(" "),
                                      topic.is_link
                                        ? _c("div", {})
                                        : _c("div", {}, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "z-4 relative",
                                                class:
                                                  "theme-" +
                                                  topic.color_theme.main,
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "mv5",
                                                    class:
                                                      "b--" +
                                                      topic.color_theme.main,
                                                    attrs: { id: topic.slug },
                                                  },
                                                  [
                                                    topic.is_phase1
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "relative",
                                                          },
                                                          [
                                                            _c("div", {
                                                              staticClass:
                                                                "f4 is-tablet-regular pb4 lh-copy topic-copy",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    _vm.marked(
                                                                      topic.description
                                                                    )
                                                                  ),
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            topic.phase1_video_id
                                                              ? _c(
                                                                  "bg-vimeo-video-embed",
                                                                  {
                                                                    staticClass:
                                                                      "mr0 mr6-ns",
                                                                    attrs: {
                                                                      vimeoVideoId:
                                                                        topic.phase1_video_id,
                                                                    },
                                                                  }
                                                                )
                                                              : _c("img", {
                                                                  directives: [
                                                                    {
                                                                      name: "lazy",
                                                                      rawName:
                                                                        "v-lazy",
                                                                      value:
                                                                        topic.phase1_image,
                                                                      expression:
                                                                        "topic.phase1_image",
                                                                    },
                                                                  ],
                                                                  staticClass:
                                                                    "img-responsive absolute left-0 pr4-ns",
                                                                  attrs: {
                                                                    alt: topic.title,
                                                                  },
                                                                }),
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "div",
                                                          [
                                                            _c("div", {
                                                              staticClass:
                                                                "f4 is-tablet-regular pb4 lh-copy topic-copy",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    _vm.marked(
                                                                      topic.description
                                                                    )
                                                                  ),
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              topic.items,
                                                              function (
                                                                event,
                                                                eIndex
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    ref: "exprow",
                                                                    refInFor: true,
                                                                    staticClass:
                                                                      "exp-row",
                                                                    class: {
                                                                      colorActive:
                                                                        _vm.desktopActive2 ==
                                                                        eIndex,
                                                                    },
                                                                    on: {
                                                                      mouseover:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.desktopActive2 =
                                                                            eIndex
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "transition",
                                                                      {
                                                                        on: {
                                                                          beforeEnter:
                                                                            _vm.beforeEnter2,
                                                                          enter:
                                                                            _vm.enter2,
                                                                          leave:
                                                                            _vm.leave2,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "show",
                                                                                  rawName:
                                                                                    "v-show",
                                                                                  value:
                                                                                    _vm.desktopActive2 !==
                                                                                    eIndex,
                                                                                  expression:
                                                                                    "desktopActive2 !== eIndex",
                                                                                },
                                                                              ],
                                                                            staticClass:
                                                                              "relative pa4 w-100",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "row middle-sm",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "col-xs-12 col-sm-6 pv4",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "img",
                                                                                      {
                                                                                        staticClass:
                                                                                          "db relative center w-100 mw6",
                                                                                        attrs:
                                                                                          {
                                                                                            src: event.image,
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "col-xs-12 col-sm-6",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "h4",
                                                                                      {
                                                                                        ref: event.title,
                                                                                        refInFor: true,
                                                                                        staticClass:
                                                                                          "f3 is-tablet-wide-bold pb2 is-navy",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            event.title
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "h1",
                                                                                      {
                                                                                        staticClass:
                                                                                          "f15px is-tablet-bold pb4 lh-20px is-tablet-regular is-navy",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            event.when
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    event.text
                                                                                      ? _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "f15px is-tablet-regular pb3 lh-copy",
                                                                                            domProps:
                                                                                              {
                                                                                                innerHTML:
                                                                                                  _vm._s(
                                                                                                    _vm.marked(
                                                                                                      event.text
                                                                                                    )
                                                                                                  ),
                                                                                              },
                                                                                          }
                                                                                        )
                                                                                      : _vm._e(),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "transition",
                                                                      {
                                                                        on: {
                                                                          beforeEnter:
                                                                            _vm.beforeEnter,
                                                                          enter:
                                                                            _vm.enter,
                                                                          leave:
                                                                            _vm.leave,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "show",
                                                                                  rawName:
                                                                                    "v-show",
                                                                                  value:
                                                                                    _vm.desktopActive2 ==
                                                                                    eIndex,
                                                                                  expression:
                                                                                    "desktopActive2 == eIndex",
                                                                                },
                                                                              ],
                                                                            staticClass:
                                                                              "pa4 w-100",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "row middle-sm",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "col-xs-12 col-sm-6",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "img",
                                                                                      {
                                                                                        staticClass:
                                                                                          "db relative center w-100 mw6",
                                                                                        attrs:
                                                                                          {
                                                                                            src: event.image,
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "col-xs-12 col-sm-6 cms-content is-experience",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "h4",
                                                                                      {
                                                                                        ref: event.title,
                                                                                        refInFor: true,
                                                                                        staticClass:
                                                                                          "f-2 is-tablet-wide-bold pb2 is-beige",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            event.title
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "h1",
                                                                                      {
                                                                                        staticClass:
                                                                                          "f15px is-tablet-bold pb4 lh-20px is-tablet-regular is-beige",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            event.when
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    event.text
                                                                                      ? _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "f15px is-tablet-regular pb3 lh-copy is-beige",
                                                                                            domProps:
                                                                                              {
                                                                                                innerHTML:
                                                                                                  _vm._s(
                                                                                                    _vm.marked(
                                                                                                      event.text
                                                                                                    )
                                                                                                  ),
                                                                                              },
                                                                                          }
                                                                                        )
                                                                                      : _vm._e(),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                    ]
                                  )
                                : _vm._e()
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showGrassLandsModal,
                    expression: "showGrassLandsModal",
                  },
                ],
                staticClass: "fixed top-0 left-0 right-0 bottom-0 bg-black-70",
                staticStyle: { "z-index": "100000" },
              },
              [
                _c("div", { staticClass: "db center w-100" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "db absolute w-100 abs-vert-center left-0 right-0 center relative mt5",
                    },
                    [
                      _c("section", { staticClass: "relative mw7 center tc" }, [
                        _c(
                          "h3",
                          { staticClass: "f3 mv3 is-lorano-bold is-white" },
                          [_vm._v("Welcome to Grass Lands")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.showNot21Message,
                                expression: "!showNot21Message",
                              },
                            ],
                          },
                          [
                            _c(
                              "h3",
                              { staticClass: "f4 mv3 is-lorano-bold is-white" },
                              [
                                _vm._v(
                                  "Are you at least 21 years of age or older?"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-row items-center justify-center relative center mv3 ",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "db relative w-100 mw4 mh2 pv3 btn-generic has-orange-bg overflow-hidden link pointer",
                                    attrs: { title: "Yes", id: "ol20-gl-yes" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.userIs21Method()
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v(
                                        "\n                      Yes\n                    "
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "db relative w-100 mw4 mh2 pv3 btn-generic has-orange-bg overflow-hidden link pointer",
                                    attrs: { title: "No", id: "ol20-gl-no" },
                                    on: {
                                      click: function ($event) {
                                        _vm.userIsNot21Method()
                                        _vm.showNot21MessageMethod()
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v(
                                        "\n                      No\n                    "
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showNot21Message,
                                expression: "showNot21Message",
                              },
                            ],
                            staticClass: "relative center mv3 tc",
                          },
                          [
                            _c(
                              "h3",
                              { staticClass: "f4 mv3 is-lorano-bold is-white" },
                              [
                                _vm._v(
                                  "Sorry! You need to be of legal age to visit."
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "db relative w-100 mw5 center pv3 btn-generic has-orange-bg overflow-hidden link pointer",
                                attrs: {
                                  title: "Go Home",
                                  id: "ol19-tickets-single-day-gold",
                                  to: "/",
                                },
                              },
                              [
                                _c("span", { staticClass: "text" }, [
                                  _vm._v(
                                    "\n                    Go Home\n                  "
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }